import React from 'react';

const Document = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33325 4H25.3333C25.8855 4 26.3333 4.44772 26.3333 5V22.7574C26.3333 22.8399 26.3231 22.9213 26.3034 23H21.3333V27.9701C21.2545 27.9898 21.1731 28 21.0906 28H7.33325C6.78097 28 6.33325 27.5523 6.33325 27V5C6.33325 4.44772 6.78097 4 7.33325 4ZM21.3333 29.9902C21.2528 29.9967 21.1719 30 21.0906 30H7.33325C5.6764 30 4.33325 28.6569 4.33325 27V5C4.33325 3.34315 5.6764 2 7.33325 2H25.3333C26.9901 2 28.3333 3.34315 28.3333 5V22.7574C28.3333 22.8386 28.33 22.9196 28.3234 23H28.3333L28.3225 23.0107C28.263 23.7136 27.9572 24.3761 27.4546 24.8787L23.2119 29.1213C22.7093 29.6239 22.0468 29.9297 21.344 29.9893L21.3333 30V29.9902ZM11.7475 16L15.0404 12.7071L13.6261 11.2929L9.62615 15.2929L8.91904 16L9.62615 16.7071L13.6261 20.7071L15.0404 19.2929L11.7475 16ZM17.6261 12.7071L20.919 16L17.6261 19.2929L19.0404 20.7071L23.0404 16.7071L23.7475 16L23.0404 15.2929L19.0404 11.2929L17.6261 12.7071Z"
      fill="#A0ABB8"
    />
  </svg>
);

export default Document;
